// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__7UaY4","note":"styles_note__e5z5Z"};